
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.5 1.188a8.312 8.312 0 100 16.624 8.312 8.312 0 000-16.625zm0 15.437a7.125 7.125 0 110-14.25 7.125 7.125 0 010 14.25z","fill":"#2F6BF0"}}),_c('path',{attrs:{"d":"M11.602 6.561L9.5 8.663 7.398 6.56l-.837.837L8.663 9.5 6.56 11.602l.837.837L9.5 10.337l2.102 2.102.837-.837L10.337 9.5l2.102-2.102-.837-.837z","fill":"#2F6BF0"}})])
          )
        }
      }
    